import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-sponsor-list',
  templateUrl: './sponsor-list.component.html',
  styleUrls: ['./sponsor-list.component.sass']
})
export class SponsorListComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
